import React, { useState } from "react";
import DefaultButton from "../General/DefaultButton";
import ReactPlayer from 'react-player'

const ModelGallery = ({ photos }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);
  const active = photos[activeIndex];

  const prev = () =>
    setActiveIndex((activeIndex - 1 + photos.length) % photos.length);
  const next = () => setActiveIndex((activeIndex + 1) % photos.length);

  return (
    <>
      {/* Gallery container */}
      <div className="flex flex-col md:flex-row bg-neutral-900 rounded-xl overflow-hidden shadow-lg max-h-[600px]">
        {/* Main Viewer */}
        <div className="relative w-full md:w-3/4 bg-black flex justify-center items-center">
          {active.type === "image" && (
            <img
              src={active.src}
              alt={`${activeIndex + 1}`}
              className="max-h-full max-w-full object-contain cursor-zoom-in"
              onClick={() => setIsZoomed(true)}
            />
          )}

          {active.type === "video" && (
            <video
              src={active.src}
              controls
              className="max-h-full max-w-full object-contain"
            />
          )}

          {active.type === "youtube" && (
            <ReactPlayer src={active.src} controls={true} width="100%" height="100%" />
          )}

          {/* Arrows */}
          <button
            onClick={prev}
            className="absolute left-2 top-1/2 transform -translate-y-1/2 text-white text-3xl"
          >
            ←
          </button>
          <button
            onClick={next}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white text-3xl"
          >
            →
          </button>

          {/* Download Button */}
          {active.type === "image" && (
            <div className="absolute top-2 right-2">
              <a
                href={active.src}
                download
                className="text-white text-2xl"
                title="Download"
              >
                <DefaultButton>Download</DefaultButton>
              </a>
            </div>
          )}
        </div>

        {/* Thumbnails */}
        <div className="md:w-1/4 p-2 flex md:flex-col gap-2 overflow-x-auto md:overflow-y-auto max-h-[600px]">
          {photos.map((item, index) => {
            let thumbSrc = item.thumbnail || item.src || "/fallback.png";

            if (item.type === "youtube" ) {
              // Extract YouTube video ID from the embed URL
              const match = item.src.match(/v=([^&]+)/);
              const videoId = match?.[1];
              if (videoId) {
                thumbSrc = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
              }
            }

            return (
              <img
                key={index}
                src={thumbSrc}
                alt={`Thumb ${index}`}
                onClick={() => setActiveIndex(index)}
                className={`cursor-pointer rounded-md border-2 ${
                  index === activeIndex
                    ? "border-blue-500"
                    : "border-transparent"
                }`}
              />
            );
          })}
        </div>
      </div>

      {/* Zoom Modal */}
      {isZoomed && active.type === "image" && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center"
          onClick={() => setIsZoomed(false)}
        >
          <img
            src={active.src}
            alt="Zoomed"
            className="max-w-full max-h-full object-contain cursor-zoom-out"
          />
        </div>
      )}
    </>
  );
};

export default ModelGallery;
